module.exports = __webpack_public_path__ + "img/stock5.f041a75f.png";